import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  retailer: {
    id: `btq.type.retailer`,
    defaultMessage: 'RETAILER',
  },
  boutique: {
    id: `btq.type.boutique`,
    defaultMessage: 'BOUTIQUE',
  },
  flagshipBoutique: {
    id: `btq.type.flagshipBoutique`,
    defaultMessage: 'FLAGSHIP BOUTIQUE',
  },
  outlets: {
    id: `btq.type.outlets`,
    defaultMessage: 'OUTLETS',
  },
  serviceCenter: {
    id: `btq.type.serviceCenter`,
    defaultMessage: 'SERVICE CENTER',
  },
  address: {
    id: `btq.details.address`,
    defaultMessage: 'Address',
  },
  contacts: {
    id: `btq.details.contact`,
    defaultMessage: 'Contact',
  },
  Phone: {
    id: `btq.details.contactPhone`,
    defaultMessage: 'Phone',
  },
  fax: {
    id: `btq.details.fax`,
    defaultMessage: 'Fax',
  },
  email: {
    id: `btq.details.contactEmail`,
    defaultMessage: 'Email',
  },
  openHours: {
    id: `btq.details.openingHours`,
    defaultMessage: 'Opening Hours',
  },
  holidayHours: {
    id: `btq.details.holidayHours`,
    defaultMessage: 'Holiday Hours',
  },
  pastExhibitionsTitle: {
    id: `btq.details.pastExhibitionsTitle`,
    defaultMessage: 'Past Exhibitions',
  },
  upcomingExhibitionsTitle: {
    id: `btq.details.upcomingExhibitionsTitle`,
    defaultMessage: 'Upcoming Exhibitions',
  },
  buyingAWatch: {
    id: `boutique.buyingAWatch`,
    defaultMessage: 'Buying a Watch',
  },
  buyingAStrap: {
    id: `boutique.buyingAStrap`,
    defaultMessage: 'Buying a Strap',
  },
  pickUpInBoutique: {
    id: `boutique.pickUpInBoutique`,
    defaultMessage: 'Pick Up In Boutique',
  },
  serviceYourWatch: {
    id: `boutique.serviceYourWatch`,
    defaultMessage: 'Service Your Watch',
  },
  errorLoadingMap: {
    id: `boutique.errorLoadingMap`,
    defaultMessage: 'Error loading map',
  },
  bookAppointment: {
    id: 'boutique.bookAppointment',
    defaultMessage: 'Book an appointment',
  },
  sendAnEmail: {
    id: 'boutique.sendAnEmail',
    defaultMessage: 'Send an email',
  },
  getDirections: {
    id: 'btq.details.getDirections',
    defaultMessage: 'Get directions',
  },
  placeholderStoresGetDirections: {
    id: 'btq.placeholderStores.getDirections',
    defaultMessage: 'Get directions',
  },
  viewMore: {
    id: 'boutique.viewMore',
    defaultMessage: 'View More',
  },
  boutiquesAndRetailers: {
    defaultMessage: 'Boutiques And Retailers',
    id: 'boutiquesAndRetailers',
  },
  afBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Afghanistan',
    id: 'btq.list.heading.af',
  },
  alBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Albania',
    id: 'btq.list.heading.al',
  },
  dzBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Algeria',
    id: 'btq.list.heading.dz',
  },
  asBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in American Samoa',
    id: 'btq.list.heading.as',
  },
  adBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Andorra',
    id: 'btq.list.heading.ad',
  },
  aoBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Angola',
    id: 'btq.list.heading.ao',
  },
  aiBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Anguilla',
    id: 'btq.list.heading.ai',
  },
  agBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Antigua and Barbuda',
    id: 'btq.list.heading.ag',
  },
  arBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Argentina',
    id: 'btq.list.heading.ar',
  },
  amBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Armenia',
    id: 'btq.list.heading.am',
  },
  awBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Aruba',
    id: 'btq.list.heading.aw',
  },
  auBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Australia',
    id: 'btq.list.heading.au',
  },
  atBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Austria',
    id: 'btq.list.heading.at',
  },
  azBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Azerbaijan',
    id: 'btq.list.heading.az',
  },
  bsBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Bahamas',
    id: 'btq.list.heading.bs',
  },
  bhBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Bahrain',
    id: 'btq.list.heading.bh',
  },
  bdBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Bangladesh',
    id: 'btq.list.heading.bd',
  },
  bbBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Barbados',
    id: 'btq.list.heading.bb',
  },
  byBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Belarus',
    id: 'btq.list.heading.by',
  },
  beBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Belgium',
    id: 'btq.list.heading.be',
  },
  bzBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Belize',
    id: 'btq.list.heading.bz',
  },
  bjBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Benin',
    id: 'btq.list.heading.bj',
  },
  bmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Bermuda',
    id: 'btq.list.heading.bm',
  },
  btBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Bhutan',
    id: 'btq.list.heading.bt',
  },
  boBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Bolivia',
    id: 'btq.list.heading.bo',
  },
  baBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Bosnia and Herzegovina',
    id: 'btq.list.heading.ba',
  },
  bwBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Botswana',
    id: 'btq.list.heading.bw',
  },
  brBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Brazil',
    id: 'btq.list.heading.br',
  },
  ioBtqlistHeading: {
    defaultMessage:
      'Official Breitling Boutique in British Indian Ocean Territory',
    id: 'btq.list.heading.io',
  },
  vgBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in British Virgin Islands',
    id: 'btq.list.heading.vg',
  },
  bnBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Brunei',
    id: 'btq.list.heading.bn',
  },
  bgBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Bulgaria',
    id: 'btq.list.heading.bg',
  },
  bfBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Burkina Faso',
    id: 'btq.list.heading.bf',
  },
  biBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Burundi',
    id: 'btq.list.heading.bi',
  },
  khBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Cambodia',
    id: 'btq.list.heading.kh',
  },
  cmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Cameroon',
    id: 'btq.list.heading.cm',
  },
  caBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Canada',
    id: 'btq.list.heading.ca',
  },
  cvBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Cape Verde',
    id: 'btq.list.heading.cv',
  },
  bqBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Caribbean Netherlands',
    id: 'btq.list.heading.bq',
  },
  kyBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Cayman Islands',
    id: 'btq.list.heading.ky',
  },
  cfBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Central African Republic',
    id: 'btq.list.heading.cf',
  },
  tdBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Chad',
    id: 'btq.list.heading.td',
  },
  clBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Chile',
    id: 'btq.list.heading.cl',
  },
  cnBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in China',
    id: 'btq.list.heading.cn',
  },
  cxBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Christmas Island',
    id: 'btq.list.heading.cx',
  },
  ccBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Cocos (Keeling) Islands',
    id: 'btq.list.heading.cc',
  },
  coBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Colombia',
    id: 'btq.list.heading.co',
  },
  kmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Comoros',
    id: 'btq.list.heading.km',
  },
  cdBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Congo (DRC)',
    id: 'btq.list.heading.cd',
  },
  cgBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Congo (Republic)',
    id: 'btq.list.heading.cg',
  },
  ckBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Cook Islands',
    id: 'btq.list.heading.ck',
  },
  crBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Costa Rica',
    id: 'btq.list.heading.cr',
  },
  ciBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Côte d’Ivoire',
    id: 'btq.list.heading.ci',
  },
  hrBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Croatia',
    id: 'btq.list.heading.hr',
  },
  cuBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Cuba',
    id: 'btq.list.heading.cu',
  },
  cwBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Curaçao',
    id: 'btq.list.heading.cw',
  },
  cyBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Cyprus',
    id: 'btq.list.heading.cy',
  },
  czBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Czechia',
    id: 'btq.list.heading.cz',
  },
  dkBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Denmark',
    id: 'btq.list.heading.dk',
  },
  djBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Djibouti',
    id: 'btq.list.heading.dj',
  },
  dmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Dominica',
    id: 'btq.list.heading.dm',
  },
  doBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Dominican Republic',
    id: 'btq.list.heading.do',
  },
  ecBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Ecuador',
    id: 'btq.list.heading.ec',
  },
  egBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Egypt',
    id: 'btq.list.heading.eg',
  },
  svBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in El Salvador',
    id: 'btq.list.heading.sv',
  },
  gqBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Equatorial Guinea',
    id: 'btq.list.heading.gq',
  },
  erBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Eritrea',
    id: 'btq.list.heading.er',
  },
  eeBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Estonia',
    id: 'btq.list.heading.ee',
  },
  etBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Ethiopia',
    id: 'btq.list.heading.et',
  },
  fkBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Falkland Islands',
    id: 'btq.list.heading.fk',
  },
  foBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Faroe Islands',
    id: 'btq.list.heading.fo',
  },
  fjBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Fiji',
    id: 'btq.list.heading.fj',
  },
  fiBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Finland',
    id: 'btq.list.heading.fi',
  },
  frBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in France',
    id: 'btq.list.heading.fr',
  },
  gfBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in French Guiana',
    id: 'btq.list.heading.gf',
  },
  pfBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in French Polynesia',
    id: 'btq.list.heading.pf',
  },
  gaBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Gabon',
    id: 'btq.list.heading.ga',
  },
  gmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Gambia',
    id: 'btq.list.heading.gm',
  },
  geBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Georgia',
    id: 'btq.list.heading.ge',
  },
  deBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Germany',
    id: 'btq.list.heading.de',
  },
  ghBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Ghana',
    id: 'btq.list.heading.gh',
  },
  giBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Gibraltar',
    id: 'btq.list.heading.gi',
  },
  grBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Greece',
    id: 'btq.list.heading.gr',
  },
  glBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Greenland',
    id: 'btq.list.heading.gl',
  },
  gdBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Grenada',
    id: 'btq.list.heading.gd',
  },
  gpBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Guadeloupe',
    id: 'btq.list.heading.gp',
  },
  guBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Guam',
    id: 'btq.list.heading.gu',
  },
  gtBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Guatemala',
    id: 'btq.list.heading.gt',
  },
  ggBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Guernsey',
    id: 'btq.list.heading.gg',
  },
  gnBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Guinea',
    id: 'btq.list.heading.gn',
  },
  gwBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Guinea-Bissau',
    id: 'btq.list.heading.gw',
  },
  gyBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Guyana',
    id: 'btq.list.heading.gy',
  },
  htBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Haiti',
    id: 'btq.list.heading.ht',
  },
  hnBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Honduras',
    id: 'btq.list.heading.hn',
  },
  hkBtqlistHeading: {
    defaultMessage:
      "Official Breitling Boutique in Hong Kong (People's Republic of China)",
    id: 'btq.list.heading.hk',
  },
  huBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Hungary',
    id: 'btq.list.heading.hu',
  },
  isBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Iceland',
    id: 'btq.list.heading.is',
  },
  inBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in India',
    id: 'btq.list.heading.in',
  },
  idBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Indonesia',
    id: 'btq.list.heading.id',
  },
  irBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Iran',
    id: 'btq.list.heading.ir',
  },
  iqBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Iraq',
    id: 'btq.list.heading.iq',
  },
  ieBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Ireland',
    id: 'btq.list.heading.ie',
  },
  imBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Isle of Man',
    id: 'btq.list.heading.im',
  },
  ilBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Israel',
    id: 'btq.list.heading.il',
  },
  itBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Italy',
    id: 'btq.list.heading.it',
  },
  jmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Jamaica',
    id: 'btq.list.heading.jm',
  },
  jpBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Japan',
    id: 'btq.list.heading.jp',
  },
  jeBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Jersey',
    id: 'btq.list.heading.je',
  },
  joBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Jordan',
    id: 'btq.list.heading.jo',
  },
  kzBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Kazakhstan',
    id: 'btq.list.heading.kz',
  },
  keBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Kenya',
    id: 'btq.list.heading.ke',
  },
  kiBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Kiribati',
    id: 'btq.list.heading.ki',
  },
  xkBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Kosovo',
    id: 'btq.list.heading.xk',
  },
  kwBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Kuwait',
    id: 'btq.list.heading.kw',
  },
  kgBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Kyrgyzstan',
    id: 'btq.list.heading.kg',
  },
  laBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Laos',
    id: 'btq.list.heading.la',
  },
  lvBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Latvia',
    id: 'btq.list.heading.lv',
  },
  lbBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Lebanon',
    id: 'btq.list.heading.lb',
  },
  lsBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Lesotho',
    id: 'btq.list.heading.ls',
  },
  lrBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Liberia',
    id: 'btq.list.heading.lr',
  },
  lyBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Libya',
    id: 'btq.list.heading.ly',
  },
  liBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Liechtenstein',
    id: 'btq.list.heading.li',
  },
  ltBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Lithuania',
    id: 'btq.list.heading.lt',
  },
  luBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Luxembourg',
    id: 'btq.list.heading.lu',
  },
  moBtqlistHeading: {
    defaultMessage:
      "Official Breitling Boutique in Macau (People's Republic of China)",
    id: 'btq.list.heading.mo',
  },
  mkBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Macedonia',
    id: 'btq.list.heading.mk',
  },
  mgBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Madagascar',
    id: 'btq.list.heading.mg',
  },
  mwBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Malawi',
    id: 'btq.list.heading.mw',
  },
  myBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Malaysia',
    id: 'btq.list.heading.my',
  },
  mvBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Maldives',
    id: 'btq.list.heading.mv',
  },
  mlBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Mali',
    id: 'btq.list.heading.ml',
  },
  mtBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Malta',
    id: 'btq.list.heading.mt',
  },
  mhBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Marshall Islands',
    id: 'btq.list.heading.mh',
  },
  mqBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Martinique',
    id: 'btq.list.heading.mq',
  },
  mrBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Mauritania',
    id: 'btq.list.heading.mr',
  },
  muBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Mauritius',
    id: 'btq.list.heading.mu',
  },
  ytBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Mayotte',
    id: 'btq.list.heading.yt',
  },
  mxBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Mexico',
    id: 'btq.list.heading.mx',
  },
  fmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Micronesia',
    id: 'btq.list.heading.fm',
  },
  mdBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Moldova',
    id: 'btq.list.heading.md',
  },
  mcBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Monaco',
    id: 'btq.list.heading.mc',
  },
  mnBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Mongolia',
    id: 'btq.list.heading.mn',
  },
  meBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Montenegro',
    id: 'btq.list.heading.me',
  },
  msBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Montserrat',
    id: 'btq.list.heading.ms',
  },
  maBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Morocco',
    id: 'btq.list.heading.ma',
  },
  mzBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Mozambique',
    id: 'btq.list.heading.mz',
  },
  mmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Myanmar',
    id: 'btq.list.heading.mm',
  },
  naBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Namibia',
    id: 'btq.list.heading.na',
  },
  nrBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Nauru',
    id: 'btq.list.heading.nr',
  },
  npBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Nepal',
    id: 'btq.list.heading.np',
  },
  nlBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Netherlands',
    id: 'btq.list.heading.nl',
  },
  ncBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in New Caledonia',
    id: 'btq.list.heading.nc',
  },
  nzBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in New Zealand',
    id: 'btq.list.heading.nz',
  },
  niBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Nicaragua',
    id: 'btq.list.heading.ni',
  },
  neBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Niger',
    id: 'btq.list.heading.ne',
  },
  ngBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Nigeria',
    id: 'btq.list.heading.ng',
  },
  nuBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Niue',
    id: 'btq.list.heading.nu',
  },
  nfBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Norfolk Island',
    id: 'btq.list.heading.nf',
  },
  kpBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in North Korea',
    id: 'btq.list.heading.kp',
  },
  mpBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Northern Mariana Islands',
    id: 'btq.list.heading.mp',
  },
  noBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Norway',
    id: 'btq.list.heading.no',
  },
  omBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Oman',
    id: 'btq.list.heading.om',
  },
  pkBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Pakistan',
    id: 'btq.list.heading.pk',
  },
  pwBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Palau',
    id: 'btq.list.heading.pw',
  },
  psBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Palestine',
    id: 'btq.list.heading.ps',
  },
  paBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Panama',
    id: 'btq.list.heading.pa',
  },
  pgBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Papua New Guinea',
    id: 'btq.list.heading.pg',
  },
  pyBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Paraguay',
    id: 'btq.list.heading.py',
  },
  peBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Peru',
    id: 'btq.list.heading.pe',
  },
  phBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Philippines',
    id: 'btq.list.heading.ph',
  },
  plBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Poland',
    id: 'btq.list.heading.pl',
  },
  ptBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Portugal',
    id: 'btq.list.heading.pt',
  },
  prBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Puerto Rico',
    id: 'btq.list.heading.pr',
  },
  qaBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Qatar',
    id: 'btq.list.heading.qa',
  },
  reBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Réunion',
    id: 'btq.list.heading.re',
  },
  roBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Romania',
    id: 'btq.list.heading.ro',
  },
  ruBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Russia',
    id: 'btq.list.heading.ru',
  },
  rwBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Rwanda',
    id: 'btq.list.heading.rw',
  },
  blBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Saint Barthélemy',
    id: 'btq.list.heading.bl',
  },
  shBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Saint Helena',
    id: 'btq.list.heading.sh',
  },
  knBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Saint Kitts and Nevis',
    id: 'btq.list.heading.kn',
  },
  lcBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Saint Lucia',
    id: 'btq.list.heading.lc',
  },
  mfBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Saint Martin',
    id: 'btq.list.heading.mf',
  },
  pmBtqlistHeading: {
    defaultMessage:
      'Official Breitling Boutique in Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    id: 'btq.list.heading.pm',
  },
  vcBtqlistHeading: {
    defaultMessage:
      'Official Breitling Boutique in Saint Vincent and the Grenadines',
    id: 'btq.list.heading.vc',
  },
  wsBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Samoa',
    id: 'btq.list.heading.ws',
  },
  smBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in San Marino',
    id: 'btq.list.heading.sm',
  },
  stBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in São Tomé and Príncipe',
    id: 'btq.list.heading.st',
  },
  saBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Saudi Arabia',
    id: 'btq.list.heading.sa',
  },
  snBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Senegal',
    id: 'btq.list.heading.sn',
  },
  rsBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Serbia',
    id: 'btq.list.heading.rs',
  },
  scBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Seychelles',
    id: 'btq.list.heading.sc',
  },
  slBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Sierra Leone',
    id: 'btq.list.heading.sl',
  },
  sgBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Singapore',
    id: 'btq.list.heading.sg',
  },
  sxBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Sint Maarten',
    id: 'btq.list.heading.sx',
  },
  skBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Slovakia',
    id: 'btq.list.heading.sk',
  },
  siBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Slovenia',
    id: 'btq.list.heading.si',
  },
  sbBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Solomon Islands',
    id: 'btq.list.heading.sb',
  },
  soBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Somalia',
    id: 'btq.list.heading.so',
  },
  zaBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in South Africa',
    id: 'btq.list.heading.za',
  },
  krBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in South Korea',
    id: 'btq.list.heading.kr',
  },
  ssBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in South Sudan',
    id: 'btq.list.heading.ss',
  },
  esBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Spain',
    id: 'btq.list.heading.es',
  },
  lkBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Sri Lanka',
    id: 'btq.list.heading.lk',
  },
  sdBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Sudan',
    id: 'btq.list.heading.sd',
  },
  srBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Suriname',
    id: 'btq.list.heading.sr',
  },
  sjBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Svalbard and Jan Mayen',
    id: 'btq.list.heading.sj',
  },
  szBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Swaziland',
    id: 'btq.list.heading.sz',
  },
  seBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Sweden',
    id: 'btq.list.heading.se',
  },
  chBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Switzerland',
    id: 'btq.list.heading.ch',
  },
  syBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Syria',
    id: 'btq.list.heading.sy',
  },
  twBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Republic of China',
    id: 'btq.list.heading.tw',
  },
  tjBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Tajikistan',
    id: 'btq.list.heading.tj',
  },
  tzBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Tanzania',
    id: 'btq.list.heading.tz',
  },
  thBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Thailand',
    id: 'btq.list.heading.th',
  },
  tlBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Timor-Leste',
    id: 'btq.list.heading.tl',
  },
  tgBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Togo',
    id: 'btq.list.heading.tg',
  },
  tkBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Tokelau',
    id: 'btq.list.heading.tk',
  },
  toBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Tonga',
    id: 'btq.list.heading.to',
  },
  ttBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Trinidad and Tobago',
    id: 'btq.list.heading.tt',
  },
  tnBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Tunisia',
    id: 'btq.list.heading.tn',
  },
  trBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Türkiye',
    id: 'btq.list.heading.tr',
  },
  tmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Turkmenistan',
    id: 'btq.list.heading.tm',
  },
  tcBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Turks and Caicos Islands',
    id: 'btq.list.heading.tc',
  },
  tvBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Tuvalu',
    id: 'btq.list.heading.tv',
  },
  viBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in U.S. Virgin Islands',
    id: 'btq.list.heading.vi',
  },
  ugBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Uganda',
    id: 'btq.list.heading.ug',
  },
  uaBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Ukraine',
    id: 'btq.list.heading.ua',
  },
  aeBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in United Arab Emirates',
    id: 'btq.list.heading.ae',
  },
  gbBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in United Kingdom',
    id: 'btq.list.heading.gb',
  },
  usBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in United States',
    id: 'btq.list.heading.us',
  },
  uyBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Uruguay',
    id: 'btq.list.heading.uy',
  },
  uzBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Uzbekistan',
    id: 'btq.list.heading.uz',
  },
  vuBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Vanuatu',
    id: 'btq.list.heading.vu',
  },
  vaBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Vatican City',
    id: 'btq.list.heading.va',
  },
  veBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Venezuela',
    id: 'btq.list.heading.ve',
  },
  vnBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Vietnam',
    id: 'btq.list.heading.vn',
  },
  wfBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Wallis and Futuna',
    id: 'btq.list.heading.wf',
  },
  ehBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Western Sahara',
    id: 'btq.list.heading.eh',
  },
  yeBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Yemen',
    id: 'btq.list.heading.ye',
  },
  zmBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Zambia',
    id: 'btq.list.heading.zm',
  },
  zwBtqlistHeading: {
    defaultMessage: 'Official Breitling Boutique in Zimbabwe',
    id: 'btq.list.heading.zw',
  },
  nextPage: {
    defaultMessage: 'Next Page',
    id: 'boutique.nextPage',
  },
  goToPage: {
    defaultMessage: 'Go to page {page}',
    id: 'boutique.goToPage',
  },
  previousPage: {
    defaultMessage: 'Go to previous page',
    id: 'boutique.previousPage',
  },
  nextPageNumber: {
    defaultMessage: 'Go to next page',
    id: 'boutique.nextPageNumber',
  },
  openNow: {
    defaultMessage: 'Open Now',
    id: 'boutique.openNow',
  },
  open: {
    defaultMessage: 'Open',
    id: 'boutique.open',
  },
  closed: {
    defaultMessage: 'Closed',
    id: 'boutique.closed',
  },
  temporaryClosed: {
    defaultMessage: 'Opening Hours Unavailable',
    id: 'boutique.temporaryClosed',
  },
  temporaryClosedUntil: {
    defaultMessage: 'Temporarly closed until',
    id: 'boutique.temporaryClosedUntil',
  },
  startBusiness: {
    defaultMessage: 'Opens',
    id: 'boutique.startBusiness',
  },
  placeholderStoresViewMore: {
    id: 'btq.placeholderStores.viewMore',
    defaultMessage: 'View more',
  },
  placeholderStoresBookAppointment: {
    id: 'btq.placeholderStores.bookAppointment',
    defaultMessage: 'Book an appointment',
  },
  placeholderStoresViewDetails: {
    id: 'btq.placeholderStores.viewBoutiqueDetails',
    defaultMessage: 'View Boutique Details',
  },
  allRegions: {
    id: 'btq.allRegions',
    defaultMessage: 'All regions',
  },
});
